import React, { Component, useEffect } from 'react';

import { cf } from './cf';
import { ce } from './ce';
import { ic } from './ic';
import { bf } from './bf';

class cView extends Component {

  $cd_stss = {}; // 外部で定義
  $id_stss = {}; // 外部で定義

//  $cp_onUmt = null; // on unmount
  $cp_onEtr = () => new Promise( _o_end1 => { _o_end1() }); // on enter
  $ip_onEtr = () => new Promise( _o_end1 => { _o_end1() }); // on enter

  $cp_onExit = () => new Promise( _o_end1 => { _o_end1() }); // on exit
  $ip_onExit = () => new Promise( _o_end1 => { _o_end1() }); // on exit

  $clp_bfrLoads = () => []; // ins/upd の前処理
  $ilp_bfrLoads = () => []; // ins/upd の前処理

  $clp_loads = () => []; // 外部で定義　※関数でない場合は値が固定化される模様
  $ilp_loads = () => []; // 外部で定義

  $clp_bfrIuds = () => []; // ins/upd の前処理
  $ilp_bfrIuds = () => []; // ins/upd の前処理

  $cp_ins = null; // 外部で定義
  $ip_ins = null; // 外部で定義

  $clp_upds = () => []; // 外部で定義
  $ilp_upds = () => []; // 外部で定義

/* 最終要素でのみ実行
  constructor(props) { // global.c は使用不可
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
    bf.myCM_clw(60, () => {}); // 定期的に実行する処理を記述

    cf.myLS_get('tkn').then((_tkn) => { // tkn が設定されていない場合　ログアウト
      if (!bf.f(_tkn)) { // myRN_logout の場合 global.c? が指定されており正常に動作しない模様
        cf.myRN_logout();
      };
    });
  }
*/

  componentDidMount() {        
    cf.myRN_stt(this, ()=>{ // 画面遷移時の再描画に必要 1/2
      cf.myRN_pll([
        global.c?.$cp_onEtr(), // on enter
        global.c?.$ip_onEtr(),
      ])
      .then(() => {
        global.c?.load();
      });
    });
  }

  componentWillUnmount() { // 画面遷移時の再描画に必要 2/2
/*
    if (global.c?.$cp_onUmt) {
      global.c?.$cp_onUmt(); // on unmount
    };
    if (global.c?.$ip_onUmt) {
//alert('59:hello.');
      global.c?.$ip_onUmt(); // on unmount
    };
*/
//alert('71:hello.')
    cf.myRN_end();
  }

/*
  onMoveFwd = () => {
    if (global.c?.$cp_onMoveFwd) {
      global.c?.$cp_onMoveFwd(); // on unmount
    };
    if (global.c?.$ip_onMoveFwd) {
      global.c?.$ip_onMoveFwd(); // on unmount
    };
  };
*/
//  onMoveFwd = () => new Promise( _o_end1 => {
/*
  onMoveFwd = (pd={}) => new Promise( _o_end1 => {
    cf.myRN_pll([
      global.c?.$cp_onMoveFwd(pd),
      global.c?.$ip_onMoveFwd(pd),
    ])
    .then(() => {
      _o_end1();
    });
  });
*/
  onExit = () => new Promise( _o_end1 => { // 現行、move_bwd では対応できていない
    cf.myRN_pll([
      global.c?.$cp_onExit(),
      global.c?.$ip_onExit(),
    ])
    .then(() => {
      _o_end1();
    });
  });

/*
  load = () => {
    global.c?.setState(bf.myCM_upd( // load との統一が必要か
      global.c?.$cd_stss,
      global.c?.$id_stss
    ), () => {
      cf.myRN_pll(bf.myCM_join( // ins/upd の前処理
        global.c?.$clp_bfrLoads(),
        global.c?.$ilp_bfrLoads()
      ))
      .then((_b_res)=>{
        cf.myRN_load(bf.myCM_join(
          global.c?.$clp_loads(),
          global.c?.$ilp_loads()
        ));
      });
    })
  }
 */
  load = () => new Promise( _o_end1 => {
    cf.s();
    global.c?.setState(bf.myCM_upd( // load との統一が必要か
      global.c?.$cd_stss,
      global.c?.$id_stss
    ), () => {
      cf.myRN_pll(bf.myCM_join( // ins/upd の前処理
        global.c?.$clp_bfrLoads(),
        global.c?.$ilp_bfrLoads()
      ))
      .then((_b_res)=>{
        cf.myRN_load(bf.myCM_join(
          global.c?.$clp_loads(),
          global.c?.$ilp_loads()
        ))
        .then(() => {
          cf.h();
          _o_end1();
        });
      });
    })
  });

  ins = () => {
    cf.s();
    cf.myRN_pll(bf.myCM_join( // ins/upd の前処理
      global.c?.$clp_bfrIuds(),
      global.c?.$ilp_bfrIuds()
    ))
    .then((_b_res)=>{
//alert('134:{}'.f(_b_res))
      if (_b_res != false) { // 異常でない場合のみ更新
        if (bf.f(global.c?.$cp_ins)) {
          cf.myRN_ins(
            global.c?.$cp_ins()
          )
        };
        if (bf.f(global.c?.$ip_ins)) { // upd が二重に実行されるため、どちらか一方のみ
          cf.myRN_ins(
            global.c?.$ip_ins()
          )
        };
      };
    })
  };

  upd = () => {
    cf.s();
    cf.myRN_pll(bf.myCM_join( // ins/upd の前処理
      global.c?.$clp_bfrIuds(),
      global.c?.$ilp_bfrIuds()
    ))
    .then((_b_res)=>{
      if (_b_res != false) { // 異常でない場合のみ更新
        cf.myRN_upd(bf.myCM_join(
          global.c?.$clp_upds(),
          global.c?.$ilp_upds()
        ));
      };
    })
  };
  //
  $onPrsTab = pd_prms => new Promise( _o_end1 => {
    global.c?.setState({
      sgcn_pageTab: pd_prms.n_tab,
    }, () => {
      _o_end1();
    });
  });

  $cld_onChgss = () => [ // common app
/*
    {
      'fnc': () => {
      },
      'vals': [
      ],
    },
*/
  ];

  $ild_onChgss = () => [ // individual app
/*
    {
      'fnc': () => {
      },
      'vals': [
      ],
    },
*/
  ];

/*
  $pld_onChgss = () => [ // practical module
  ];
*/
/*
  $pld_onChgss = () => [
    {
      state: 'effect',
      o_eft: () => {},
    }
  ];
*/
  $pdo_onChgs = () => ({
    state: () => {},
  });

  $onChg = p_props => { // observer, render 関数を <this.$onChg></this.$onChg> をくくる, load や blur で処理する内容は適さない

    for (let [_idx, _d_defs] of bf.e(this.$cld_onChgss())) { // 画面共通の処理（ iv において定義）
      useEffect(_d_defs.fnc, _d_defs.vals);
    };

    for (let [_idx, _d_defs] of bf.e(this.$ild_onChgss())) { // 画面個別の処理
      useEffect(_d_defs.fnc, _d_defs.vals);
    };

/*
    for (let [_idx, _d_defs] of bf.e(this.$pld_onChgss())) { // 画面個別の処理
      useEffect(_d_defs.fnc, _d_defs.vals);
    };
*/
/*
    Object.keys(this.$pdo_onChgs)
    .map( _key => {
bf.l('219:{}, {}'.f(_key, this.$pdo_onChgs[_key]))
      useEffect(() => this.$pdo_onChgs[_key], [global.c?.state[_key]]);
    });
*/
/*
    this.$pld_onChgss
    .map( _d_is => {
      useEffect(_d_is.o_eft, [_d_is.state]);
    });
*/
/*
    for (let [_idx, _d_defs] of bf.e(this.$pld_onChgss())) { // 画面個別の処理
      useEffect(_d_defs.o_eft, [_d_defs.state]);
    };
*/

    let _do_onChgs = this.$pdo_onChgs();
    Object.keys(_do_onChgs)
    .map( _key => {
      useEffect(_do_onChgs[_key], [global.c?.state[_key]]);
    });

    return p_props.children;
  };

};

export default cView;

